import Skeleton from "../super-admin-dashboard/Skeleton";
import styles from "./PrioritySummaryCards.module.css";

const clampPercent = (value) => {
  const num = Number(value);
  if (!Number.isFinite(num)) return 0;
  if (num < 0) return 0;
  if (num > 100) return 100;
  return Math.round(num);
};

const PrioritySummaryCards = ({
  twoWaysCompleted = 0,
  carePlansCompleted = 0,
  readingsReviewed = 0,
  totalPatients = 0,
  readingsReviewedPercentage,
  loading = false,
}) => {
  const safeTotal = Math.max(0, Number(totalPatients) || 0);
  const safeReviewed = Math.max(0, Number(readingsReviewed) || 0);
  const completionPercent = clampPercent(readingsReviewedPercentage);
  const percentLabel = `${completionPercent} % completed`;

  return (
    <div className={styles.summaryGrid}>
      <div className={styles.card}>
        <p className={styles.title}>Two-ways Completed This Month</p>
        {loading ? (
          <Skeleton width="72px" height="32px" radius="8px" style={{ marginTop: "10px" }} />
        ) : (
          <p className={styles.value}>{twoWaysCompleted}</p>
        )}
      </div>

      <div className={styles.card}>
        <p className={styles.title}>Care Plans Completed This Month</p>
        {loading ? (
          <Skeleton width="72px" height="32px" radius="8px" style={{ marginTop: "10px" }} />
        ) : (
          <p className={styles.value}>{carePlansCompleted}</p>
        )}
      </div>

      <div className={styles.card}>
        <p className={styles.title}>Readings Reviewed</p>
        {loading ? (
          <>
            <div className={styles.reviewRow}>
              <Skeleton width="120px" height="14px" radius="999px" />
              <Skeleton width="92px" height="12px" radius="999px" />
            </div>
            <Skeleton width="100%" height="6px" radius="999px" />
          </>
        ) : (
          <>
            <div className={styles.reviewRow}>
              <span className={styles.reviewLabel}>{percentLabel}</span>
              <span className={styles.reviewCount}>{safeReviewed}/{safeTotal} Patients</span>
            </div>
            <div className={styles.progressTrack}>
              <div
                className={styles.progressBar}
                style={{ width: `${completionPercent}%` }}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PrioritySummaryCards;
